import React from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost, apiPut, apiRequest, getSpsAPiRequest, spsApiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import PageHeader from '../common/PageHeader';
import { EmployeeTerminationColumns } from '../../constants/MockData';
import GridTable from '../common/Table/Table';
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Paper,
    TextareaAutosize,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import FormGenerator from '../common/FormGenerator';
import '../PendingRequest/index.less';
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
import {
    applyFilterOnData,
    getSectionAttributesByKeyValue,
    getSectionAttributeValueByKey,
    removeDuplicates,
    RemoveSectionAttributeByKeyValue,
    setAllSectionAttributeValueByKey,
    setSectionFieldAttributeByKey,
    UpdateColumnWithConfiguration,
    UpdateFieldsWithConfiguration,
    useQuery,
    IsSectionVisible,
    cloneDeep
} from '../../utils/helper';
import moment from 'moment';
import commonLabels from '../../constants/messageConstants';
import { NavLink } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PageFilter from '../common/PageFilter';

class EmployeeTerminations extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { selectedRow: undefined, employeeTerminationsData: [] };
    }
    componentDidMount() {
        this.GetEmployeeTerminationsDetails();
    }

    GetEmployeeTerminationsDetails = () => {
        this._asyncRequest = apiBatchRequest([
            {
                url: API_URL.Employee.GetEmployeeTerminations,
                key: 'employeeTerminationsData',
                params: { notificationMasterId: this.props.notificationMasterId }
            }])
            .then(({ employeeTerminationsData }) => {
                this._asyncRequest = null;
                if (employeeTerminationsData.success === true) {
                    this.setState({
                        employeeTerminationsData: employeeTerminationsData.data || []
                    });
                }
                else {
                    ShowToast(
                        commonLabels.somethingWrong,
                        toastType.ERROR,
                        5000,
                        500,
                        'Server error'
                    );
                }
            })
            .catch(() => {
                this._asyncRequest = null;
                ShowToast(
                    commonLabels.somethingWrong,
                    toastType.ERROR,
                    5000,
                    500,
                    'Server error'
                );
            })

    }
    render() {
        const { employeeTerminationsData } = this.state;
        return (
            <>
                <div className="row">
                    <div className="col-sm-12">
                        <PageHeader
                            key={'Employee_Terminations'}
                            title={'Employee Terminations'}
                            actionsConfig={[
                                {
                                    icon: (
                                        <NavLink
                                            to={{
                                                pathname: '/Dashboard'
                                                //  navProps: {
                                                //    selectedRow: value
                                                //  }
                                            }}
                                            style={{ color: '#FFF', fontSize: 'small' }}>
                                            <ArrowBackIcon
                                                size="small"
                                                className="back-button no-print"
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </NavLink>
                                    ),
                                    // onClick: this.goBack,
                                    title: 'Back to Dashboard'
                                }
                            ]}
                        >
                            Employee Terminations
            </PageHeader>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {employeeTerminationsData === null
                            ? (
                                <>{'No Data Available'}</>
                            )
                            : (
                                <>
                                    <GridTable
                                        columns={UpdateColumnWithConfiguration(
                                            EmployeeTerminationColumns,
                                            this.state.configuration || []
                                        )}
                                        config={{ showPager: true }}
                                        data={employeeTerminationsData}
                                        renderActionColumn={this.renderActionColumn}
                                    ></GridTable>
                                </>
                            )}{' '}
                    </div>
                </div>
            </>
        );
    }
}

export default EmployeeTerminations;
